module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIuMDAxIDUxMi4wMDEiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyLjAwMSA1MTIuMDAxIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnPjxwYXRoIGQ9Im01MTIuMDAxIDg0Ljg1My04NC44NTMtODQuODUzLTE3MS4xNDcgMTcxLjE0Ny0xNzEuMTQ4LTE3MS4xNDctODQuODUzIDg0Ljg1MyAxNzEuMTQ4IDE3MS4xNDctMTcxLjE0OCAxNzEuMTQ4IDg0Ljg1MyA4NC44NTMgMTcxLjE0OC0xNzEuMTQ3IDE3MS4xNDcgMTcxLjE0NyA4NC44NTMtODQuODUzLTE3MS4xNDgtMTcxLjE0OHoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/gamega.me/close_black.svg
// module id = dTwb
// module chunks = 1